import {useI18n} from 'i18n/I18nContext'
import React, {useState} from 'react'
import {PaymentElement, useElements, useStripe} from '@stripe/react-stripe-js'
import {toast} from 'react-toastify'
import {useAttendeeBilling} from 'attendee/Billing/Providers/AttendeeBillingProvider'

export function AddCardForm() {
  const {t} = useI18n()
  const {createConfirmationIntent, getPaymentMethods, loading, setLoading} =
    useAttendeeBilling()
  const stripe = useStripe()
  const elements = useElements()

  const [errorMessage, setErrorMessage] = useState()
  const [internalLoading, setInternalLoading] = useState(false)

  const handleError = (error: any) => {
    setLoading(false)
    setErrorMessage(error.message)
  }

  const handleSubmit = async (event: any) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault()
    setInternalLoading(true)

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      setInternalLoading(false)
      return
    }

    // Trigger form validation and wallet collection
    const {error: submitError} = await elements.submit()
    if (submitError) {
      handleError(submitError)
      setInternalLoading(false)
      return
    }

    // Create the ConfirmationToken using the details collected by the Payment Element
    // and additional shipping information
    const {error, confirmationToken} = await stripe.createConfirmationToken({
      elements,
    })

    if (error) {
      // This point is only reached if there's an immediate error when
      // creating the ConfirmationToken. Show the error to your customer (for example, payment details incomplete)
      handleError(error)
      setInternalLoading(false)
      return
    }

    const response: any = await createConfirmationIntent(confirmationToken.id)

    if (response?.error) {
      toast.warn(t('orgBilling.addCardError'))
      // Show error from server in payment setup form
    } else if (response?.status === 'requires_action') {
      setLoading(true)
      // Use Stripe.js to handle the required next action
      const {error} = await stripe.handleNextAction({
        clientSecret: response?.client_secret,
      })

      if (error) {
        toast.warn(t('orgBilling.addCardError'))
      } else {
        getPaymentMethods()
        toast.success(t('orgBilling.addCardSuccess'))
      }
    } else {
      getPaymentMethods()
      toast.success(t('orgBilling.addCardSuccess'))
    }

    setLoading(false)
    setInternalLoading(false)
  }

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <button
        type="submit"
        disabled={!stripe || loading || internalLoading}
        className="element__btn red-bg w-100 text-center mt-15"
      >
        {t('orgBilling.addCardSubmit')}{' '}
        <i className="fa-regular fa-angle-right"></i>
      </button>
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  )
}
